import ConfigApplication from "../config/Application";
import ConfirmationModal from "common/utils/ConfirmationModal";
import TemplateValidation from "../common/utils/TemplateValidation";
import IndexTemplate from "../common/utils/templates/IndexTemplate";
import UnreadNotificationCenter from "../shared/UnreadNotificationCenter";

export default class Application extends ConfigApplication {
    constructor() {
        super();
        this.confirmationModal = new ConfirmationModal();
        this.datatable = null;
        this.exportdatatable = null;
        this.templateValidation = null;

        /* Templates JS */
        this.indexTemplate = null;

        $.ajaxSetup({
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            }
        });

        this.bindEvents()
    }

    pageChanged() {
        super.pageChanged();

        this.onAlertChange();
        this.onNoticeChange();
        this.onErrorChange();
        this.onSuccessChange();

        this.loadLibraries();
        this.setTemplateValidation(window.validationData);

        /* Templates JS */
        this.setIndexTemplate();
        this.setupUnreadNotifications();

        this.afterPageChanged();
    }

    afterPageChanged() {
        // Override in subclasses
    }

    bindEvents(){
        super.bindEvents();
        $(document).off('turbolinks:visit').on('turbolinks:visit', () => {
            if(this.templateValidation !== null){
                this.templateValidation.onDestroy();
                this.templateValidation = null;
            }
        })
    }

    bindEventsAfterPageChanged() {
        super.bindEventsAfterPageChanged();

        $('.js-delete-confirm').unbind('click').click(this.delete_confirm)

        this.afterBindEvents();
    }

    afterBindEvents() {
        // Override in subclasses
    }

    onAlertChange(){
        if(window.warning !== null && window.warning !== undefined && window.warning !== '') {
            this.alertNotification(window.warning);
        }
    }

    onNoticeChange(){
        if(window.notice !== null && window.notice !== undefined && window.notice !== '') {
            this.noticeNotification(window.notice);
        }
    }

    onErrorChange(){
        if(window.error !== null && window.error !== undefined && window.error !== '') {
            this.errorNotification(window.error);
        }
    }

    onSuccessChange(){
        if(window.success !== null && window.success !== undefined && window.success !== '') {
            this.successNotification(window.success);
        }
    }

    successNotification(msg){
        $.NotificationApp.send("Succès!",msg,"top-right","#5ba035","success",5000,4)
    }

    errorNotification(msg){
        $.NotificationApp.send("Erreur!",msg,"top-right","#bf441d","error",5000,4)
    }

    noticeNotification(msg){
        $.NotificationApp.send("Information!",msg,"top-right","#3b98b5","info",5000,4)
    }

    alertNotification(msg){
        $.NotificationApp.send("Attention!",msg,"top-right","#da8609","warning",5000,4)
    }

    delete_confirm() {
        let self = application
        let title = $(this).data("title");
        let message = $(this).data("message");
        let btnPositive = $(this).data("btn-confirm");
        let btnCancel = $(this).data("btn-cancel");
        let url = $(this).data("url");
        let id = $(this).data("id");
        self.confirmationModal.displayConfirm(
            title,
            message,
            {
                positive_btn: {
                    type: "danger",
                    label: btnPositive,
                    callback: function() {
                        let form = document.createElement('form');
                        form.style.visibility = 'hidden';
                        form.action = url;
                        form.method = 'post'

                        let input = document.createElement('input');
                        input.name = '_method';
                        input.value = 'delete';
                        input.type = 'hidden'
                        form.appendChild(input);

                        let inputToken = document.createElement('input');
                        inputToken.name = 'authenticity_token';
                        inputToken.value = $('meta[name="csrf-token"]').attr('content');
                        inputToken.type = 'hidden'
                        form.appendChild(inputToken);

                        document.body.appendChild(form);
                        form.submit();
                    }
                },
                negative_btn: {
                    label: btnCancel
                }
            });
    }

    loadLibraries() {
        // Override in subclasses
    }

    openLoader(){
        $("#default_loader").modal("show");
    }

    closeLoader(){
        $("#default_loader").modal("hide");
    }

    setTemplateValidation(validationData){
        if(validationData !== undefined){
            this.templateValidation = new TemplateValidation(validationData);
        }
    }

    setIndexTemplate(){
        if(this.indexTemplate !== undefined){
            this.indexTemplate = new IndexTemplate();
        }
        this.indexTemplate.onPageChanged();
    }

    setupUnreadNotifications(){
        // Override in subclasses
    }
}